import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

import { ENVIRONMENT } from '@environment';
import { LocationService } from '@usheru-hff/sdk/location';
import { Country, PageType } from '@usheru-hff/shared/domain';
import { SharedFeatureLocationSelectorModule } from '@usheru-hff/shared/feature-location-selector';
import { FeatureStreamingCountrySelectorComponent } from '@usheru-hff/shared/feature-streaming-country-selector';

@Component({
  selector: 'shared-location-widget-carousels',
  standalone: true,
  imports: [
    CommonModule,
    SharedFeatureLocationSelectorModule,
    FeatureStreamingCountrySelectorComponent,
    FontAwesomeModule
  ],
  templateUrl: './shared-location-widget-carousels.component.html',
  styleUrl: './shared-location-widget-carousels.component.scss'
})
export class SharedLocationWidgetCarouselsComponent {
  private readonly locationService = inject(LocationService);
  private readonly env = inject(ENVIRONMENT);

  readonly countryBasedApplicationEnabled = this.env.countryBasedApplication?.enabled;

  @Input() type: PageType = 'in-cinemas';
  @Output() locationChanged = new EventEmitter<boolean>();

  markericon = faLocationDot;

  handleLocationSelected(location: any) {
    this.locationChanged.emit(true);
  }

  onCountryChanged(country: Country) {
    this.locationChanged.emit(true);
  }

  get isCountrySelectorEnabled() {
    return this.locationService.getAvailableCountries().length > 1 && !this.countryBasedApplicationEnabled;
  }

  get shouldDisplay() {
    return this.type === 'watch-at-home' || this.type === 'in-cinemas';
  }
}
